(function($, Drupal, window) {
  "use strict";

  /**
   * FAQ paragraph behavior.
   */
  Drupal.behaviors.faqParagraph = {
    attach: function(context) {
      //Build TOC for each guide (category).
      $(once('node-type-guide', '.node--type-guide')).each( function() {
        var $this = $(this, context);
        var $id = $this.attr('id');
        buildFaqParagraphToc($this, $id);

        $this.find('.collapse').each(function () {

          var el = this;

          el.addEventListener('show.bs.collapse', function (e) {
            if (typeof window.Blazy !== "undefined") {
              new Blazy();
            }
          })
        })

      });

      faqPageSchemaGenerator(context);
    }
  };

  /**
   * Build the table of content for faq paragraphs
   * @param $context
   * @param parent_id
   */
  function buildFaqParagraphToc($context, parent_id) {
    var items = [];

    // Create TOC entry for each question.
    $context.find('.paragraph--type--faq .faq-question').each(function() {
      var id = $(this).attr('id');
      var item = '<a href="#' + id + '" class="toc-item" id="toc--' + id + '">' + $(this).find('.field-question').text() + '</a>';
      items.push(item);
    });

    var toc = '<div class="faq-toc"><strong class="lead" ></strong><ul>' +
      items.map(function (item) {
        return '<li>' + item + '</li>';
      }).join('') + '</ul></div>';

    // Add TOC between label (title) and first question.
    $context.find('.guide-label').after(toc);

    // Register click event, so the coll
    $context.find('.toc-item').click(function (){
      new bootstrap.Collapse($(this.hash + '.collapsed').closest('.container').find('.collapse')[0]);
    });

    // Add back-to-toc button.
    $context.find('.faq-answer > .py-3').append(
      '<a class="btn btn-primary mb-2" href="#' + parent_id + '">' + Drupal.t('To top of table of contents') + '</a>'
    );
  }

  /**
   * Build the FAQ-Page schema
   *
   * Dokumentation: https://developers.google.com/search/docs/data-types/faqpage?hl=en
   * Test structured data: https://search.google.com/structured-data/testing-tool
   */
  function faqPageSchemaGenerator(context) {

    // 1. a) Try to read structured data from script tag
    var structuredData = getStructuredDataFromDom('#structured-data-faq-page');

    if (!structuredData) {
      // 1. b) Fallback: Crate new structured data object.
      structuredData = {
        "@context": "https://schema.org/",
        "@type": "FAQPage",
        "mainEntity": []
      };
    }

    // Add questions and answers to structured data.
    $('.paragraph--type--faq', context).each(function () {
      var $this = $(this);
      var question = $this.find('.faq-question').text().trim();
      // Some markup is allowed for answers, see
      // https://developers.google.com/search/docs/data-types/faqpage?hl=de#answer
      var allowed = '<h1><h2><h3><h4><h5><h6><a><br><ol><ul><li><p><div><b><strong><i><em>';
      var answer = strip_tags($this.find('.faq-answer .field-answer').html(), allowed).trim();
      if (question && answer) {
        structuredData.mainEntity.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answer
          }
        });
      }
    });

    // Append (replace) ld+json data.
    var script = '<script id="structured-data-faq-page" type="application/ld+json">' + JSON.stringify(structuredData) + '</script>';
    $('#structured-data-faq-page').remove();
    $('head').append(script);
  }

  /**
   * Get structured data from dom.
   *
   * @param selector
   * @returns {boolean|any}
   */
  function getStructuredDataFromDom(selector) {
    try {
      var structuredData = JSON.parse($(selector).html().trim());
      if (typeof structuredData === 'object') {
        return structuredData;
      }
    } catch (e) {
      return false;
    }
  }

  /**
   * Equivalent strip_tags of PHP in javascript with allowed tags
   *
   * From  https://stackoverflow.com/a/5601929/880188
   *
   * @param str content
   * @param whitelist string with selectors, for more tags use the multiple selector, e.g. "p, img"
   */
  function strip_tags (input, allowed) {
    allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
    var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
    return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
      return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
    })
  }

})(jQuery, Drupal, window);
